<template lang="pug">

  div
    div(v-if="!decimal").p-timecount
      p-text-field.p-timecount__hour(
        :label="label",
        type="text",
        v-model="hours",
        v-mask="['#', '##', '###']",
        :loading="loading",
        :disabled="disabled",
        v-on="localListeners",
        v-bind="localAttributes"
        :error="error"
      )

      p-text-field.p-timecount__min(
        :label="labelMinutos",
        type="text",
        v-model="minutes",
        v-mask="minutesMask",
        :loading="loading",
        :disabled="disabled",
        v-on="localListeners",
        v-bind="localAttributes"
        :error="error"
      )

    div(v-else).p-timecount
      p-text-field.p-timecount__decimal(
        :label="label",
        type="text",
        v-model="float",
        :loading="loading",
        :disabled="disabled",
        v-on="localListeners",
        v-bind="localAttributes",
        :error="error",
        placeholder="00.00"
        v-mask="['#.##', '##.##', '###.##']"
      )

</template>

<script>
import PTextField from './PTextField.vue'
import { handlerUseStateVmodel } from '../mixins/handlerUseStateVmodel'
import { mask } from 'vue-the-mask'
import { floatToHoursMins, hoursMinsToFloat } from 'src/utils'

export default {
  name: 'PTimeCountField',
  mixins: [handlerUseStateVmodel()],
  directives: { mask },
  components: {
    PTextField
  },
  props: {
    loading: Boolean,
    disabled: Boolean,
    decimal: Boolean,
    error: String,
    label: {type: String, required: false, default: 'horas'},
    labelMinutos: {type: String, required: false, default: 'minutos'}
  },
  data () {
    let initialValues = {
      hours: null,
      minutes: null,
      float: null
    }
    if (this.value.float) {
      initialValues = floatToHoursMins(this.value.float)
    } else if (this.value.hours && this.value.minutes) {
      initialValues = {
        hours: this.value.hours,
        minutes: this.value.minutes,
        float: hoursMinsToFloat(this.value.hours, this.value.minutes)
      }
    }

    return {
      localListeners: undefined,
      localAttributes: undefined,
      minutesMask: {
        mask: 'm#',
        tokens: {
          '#': { pattern: /\d/ },
          'm': { pattern: /[0-5]/ }
        }
      },
      ...initialValues
    }
  },
  computed: {
    time: {
      get: function () {
        return {
          hours: this.hours,
          minutes: this.minutes,
          float: this.float
        }
      }
    }
  },
  created () {
    this.localListeners = Object.keys(this.$listeners)
      .filter(key => key !== 'input')
      // eslint-disable-next-line no-sequences
      .reduce((res, key) => (res[key] = this.$listeners[key], res), {}) // eslint-disable-line no-return-assign

    this.localAttributes = Object.keys(this.$attrs)
      .filter(key => key !== 'disabled')
      // eslint-disable-next-line no-sequences
      .reduce((res, key) => (res[key] = this.$attrs[key], res), {}) // eslint-disable-line no-return-assign

    if (this.state.float) this.float = this.state.float
  },
  methods: {
    updateValueWithFloat (float) {
      const newState = floatToHoursMins(float)
      this.minutes = newState.minutes
      this.hours = newState.hours
    }
  },
  watch: {
    time: function (newTime) {
      if (this.decimal) {
        this.state = floatToHoursMins(parseFloat(newTime.float))
      } else {
        this.state = {
          hours: parseInt(newTime.hours),
          minutes: parseInt(newTime.minutes),
          float: hoursMinsToFloat(newTime.hours, newTime.minutes)
        }
      }
    }
  }
}
</script>

<style scoped>
.p-timecount {
  display: flex;
  align-items: center;
}

.p-timecount__hour {
  /* border: 1px solid red; */
  width: 70px;
  margin-right: 10px;
}

.p-timecount__min {
  /* border: 1px solid brown; */
  width: 70px;
}

.p-timecount__decimal {
  /* border: 1px solid brown; */
  width: 70px;
}

</style>
